// import Grox24Landing from "./Grox24Landing";
// export default function App() {
//   return <Grox24Landing />;
// }

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Grox24Landing from "./Grox24Landing";

import Disclaimer from "./pages/Disclaimer";
import DeliveryAreas from "./pages/DeliveryAreas";
import Refund from "./pages/Refund";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Landing page */}
        <Route path="/" element={<Grox24Landing />} />

        {/* Footer pages */}
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/delivery" element={<DeliveryAreas />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </Router>
  );
}